import {ValueObject} from '@s-ui/domain'

export default class SearchDataAdsValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {Object} data.breadcrumbs
   * @param {Object} data.canonical
   * @param {Object} data.metaData
   * @param {Object<SearchRequestValueObject>} data.search
   * @param {String} data.listingSectionId
   */

  getSearch() {
    return this._search
  }

  setSearch(searchRequestValueObject) {
    this._search = searchRequestValueObject
  }

  get listingSectionId() {
    return this._listingSectionId
  }

  get searchForFilters() {
    return this._search
  }
}
